const sanitizeUrl = (input: string): string => {
  if (!input || typeof input !== 'string') {
    throw new Error('Input must be a non-empty string');
  }

  const trimmed = input.trim();

  const hasProtocol = /^https?:\/\//.test(trimmed);
  const url = new URL(hasProtocol ? trimmed : `https://${trimmed}`);
  return `${url.origin}${url.pathname}`;
};

export default sanitizeUrl;
